module.exports = __webpack_public_path__ + "static/media/arrow-left.ba51f9b6.svg";